import { InjectionToken, Provider } from '@angular/core';

import { AdobeAnalytics } from './AdobeAnalytics';



export const ADOBE_ANALYTICS = new InjectionToken<AdobeAnalytics>('ADOBE_ANALYTICS');

export const ADOBE_ANALYTICS_PROVIDER: Provider = [
  {
    provide: ADOBE_ANALYTICS,
    useValue: window
  }
];
